import { jsx as r } from "react/jsx-runtime";
const l = ({ href: e, styles: n, children: t }) => /* @__PURE__ */ r("span", { style: n, children: /* @__PURE__ */ r(
  "a",
  {
    target: "_blank",
    disabled: !e,
    rel: "noopener noreferrer",
    href: e,
    children: t
  }
) });
export {
  l as default
};
//# sourceMappingURL=ExternalLink.js.map
